import 'vuetify/styles';
import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import { palette } from '@/services/colors/palette';

const vuetify = createVuetify({
  components,
  directives,
  display: {
    thresholds: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
      xxl: 2560,
    },
  },
  theme: {
    themes: {
      light: {
        colors: {
          error: palette.red,
        },
      },
    },
  },
});

export default vuetify;
